import React, { useState, useEffect, useRef } from 'react';
import styles from  './Displaybyletter.module.scss';
// eslint-disable-next-line react/prop-types
function Displaybyletter({ text = '' }) {
  const [textToDisplay, setTextToDisplay] = useState('');
  const [textState, setTextState] = useState({
    index: 0,
    isErased: false,
    isPaused: false,
    textNumber: 0,
  });
  const updateInterval = useRef();

  const { index, isPaused, isErased, textNumber } = textState;
  const getTextNumber = () => ((textNumber >= 0 && text.length - 1 !== textNumber) ? textNumber + 1 : 0);

  useEffect(() => {
    if (isPaused) return;

    const updateText = () => {
      if (isErased) {
        setTextToDisplay((prev) => {
        if (prev.length === 0) {
          setTextState({ ...textState, index: 0, isErased: false, textNumber: getTextNumber()  });
          return '';
        }
        return prev.slice(0, -1);
      })
    } else {
      if (!isErased && index >= text[textNumber].length) {
        setTextState((prevState) => ({
          ...prevState,
          isPaused: true,
          isErased:true,
        }));
        setTimeout(() => {
          setTextState((prevState) => ({
            ...prevState,
            isPaused: false,
          }));
        }, 2000);
      } else {
        setTextToDisplay((prev) => prev + text[textNumber][index]);
        setTextState((prevState) => ({
          ...prevState,
          isErased:false,
          index: index + 1,
        }));
      }
    }
    };

    updateInterval.current = setInterval(updateText, 100);

    return () => clearInterval(updateInterval.current);
  }, [text, textState]);

  return <h1 className={styles.centerText}>{textToDisplay}</h1>;
}

export default Displaybyletter;
